/* APH Wishlist - JS
   Paste as full file content in assets/aph-wishlist.js
   Adds CleverTap events on add/remove favorites.
*/
(function () {
  const STORAGE_KEY = "aph_wishlist_v1";

  // CleverTap event names (change if your manager wants different names)
  const CT_EVENT_ADD = "Added to Favorites";
  const CT_EVENT_REMOVE = "Removed from Favorites";

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = JSON.parse(raw || "[]");
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles, opts) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles || []));
    } catch (e) {}

    // If someone calls APHWishlist.write() directly (ex: Clear all), keep UI in sync
    const silent = opts && opts.silent === true;
    if (!silent) {
      setCount();
      dispatchUpdate({ action: "set", handle: "" });
    }
  }

  function has(handle) {
    if (!handle) return false;
    return read().includes(handle);
  }

  // ----------------------------
  // CleverTap safe push + queue
  // ----------------------------
  function getStoreId() {
    try {
      if (window.Shopify && Shopify.shop) return String(Shopify.shop);
    } catch (e) {}
    return String(location.hostname || "");
  }

  function ctIsReady() {
    try {
      return !!(window.clevertap && window.clevertap.event && typeof window.clevertap.event.push === "function");
    } catch (e) {
      return false;
    }
  }

  function ctPush(name, props) {
    try {
      window.clevertap.event.push(name, props || {});
      return true;
    } catch (e) {
      return false;
    }
  }

  function ctEnqueue(name, props) {
    window.__aphCtQueue = window.__aphCtQueue || [];
    window.__aphCtQueue.push({ name, props, t: Date.now() });
    ctScheduleFlush();
  }

  let ctFlushTimer = null;
  function ctScheduleFlush() {
    if (ctFlushTimer) return;

    let tries = 0;
    ctFlushTimer = setInterval(function () {
      tries += 1;

      if (ctIsReady() && window.__aphCtQueue && window.__aphCtQueue.length) {
        const q = window.__aphCtQueue.splice(0);
        q.forEach(function (ev) {
          try {
            window.clevertap.event.push(ev.name, ev.props || {});
          } catch (e) {}
        });
      }

      // Stop after a few seconds so we do not keep running forever
      if (tries >= 20 || (!window.__aphCtQueue || window.__aphCtQueue.length === 0)) {
        clearInterval(ctFlushTimer);
        ctFlushTimer = null;
      }
    }, 500);
  }

  function trackCleverTap(action, handle, handlesArr) {
    const count = Array.isArray(handlesArr) ? handlesArr.length : 0;

    const props = {
      Action: action,
      "Product Handle": String(handle || ""),
      "Favorites Count": count,
      "Page URL": String(location.href || ""),
      Store: getStoreId()
    };

    const eventName = action === "add" ? CT_EVENT_ADD : CT_EVENT_REMOVE;

    if (ctIsReady()) {
      if (!ctPush(eventName, props)) ctEnqueue(eventName, props);
    } else {
      ctEnqueue(eventName, props);
    }
  }

  function toggle(handle) {
    if (!handle) return { active: false, handles: read() };

    const handles = read();
    const idx = handles.indexOf(handle);

    let active = false;
    if (idx >= 0) {
      handles.splice(idx, 1);
      active = false;
    } else {
      handles.unshift(handle);
      active = true;
    }

    // Silent write to avoid double dispatch
    write(handles, { silent: true });

    setCount();
    dispatchUpdate({ action: active ? "add" : "remove", handle: handle });

    // CleverTap event
    trackCleverTap(active ? "add" : "remove", handle, handles);

    return { active, handles };
  }

  function setCount() {
    const els = document.querySelectorAll("[data-aph-wishlist-count]");
    if (!els.length) return;

    const hasItems = read().length > 0;

    els.forEach((el) => {
      // Dot only, no number
      el.textContent = "";
      el.style.display = hasItems ? "block" : "none";
      el.setAttribute("aria-hidden", "true");
    });
  }

  function dispatchUpdate(extraDetail) {
    const detail = Object.assign({ handles: read() }, extraDetail || {});
    document.dispatchEvent(new CustomEvent("aph:favorites:updated", { detail }));
  }

  function syncButton(btn) {
    if (!btn) return;

    const handle = btn.getAttribute("data-aph-handle");
    const active = has(handle);
    const addLabel = btn.getAttribute("data-aph-label-add");
    const removeLabel = btn.getAttribute("data-aph-label-remove");

    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");

    if (addLabel || removeLabel) {
      btn.setAttribute(
        "aria-label",
        active
          ? (removeLabel || addLabel || "Favorites")
          : (addLabel || removeLabel || "Favorites")
      );
    }
  }

  function bindButtons() {
    document.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-aph-wishlist-btn]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute("data-aph-handle");
      const result = toggle(handle);

      btn.classList.toggle("is-active", result.active);
      btn.setAttribute("aria-pressed", result.active ? "true" : "false");

      const addLabel = btn.getAttribute("data-aph-label-add");
      const removeLabel = btn.getAttribute("data-aph-label-remove");
      if (addLabel || removeLabel) {
        btn.setAttribute(
          "aria-label",
          result.active
            ? (removeLabel || addLabel || "Favorites")
            : (addLabel || removeLabel || "Favorites")
        );
      }
    });
  }

  function hydrateButtons(scope) {
    const root =
      scope && scope.querySelectorAll ? scope : document;

    const buttons = [];

    if (scope && scope.matches && scope.matches("[data-aph-wishlist-btn]")) {
      buttons.push(scope);
    }

    root.querySelectorAll("[data-aph-wishlist-btn]").forEach((btn) => buttons.push(btn));
    buttons.forEach((btn) => syncButton(btn));
  }

  function observeButtons() {
    if (!document.body || typeof MutationObserver === "undefined") return;

    let queued = false;
    const observer = new MutationObserver(function (mutations) {
      let hasRelevantNodes = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches("[data-aph-wishlist-btn]") || node.querySelector("[data-aph-wishlist-btn]")) {
            hasRelevantNodes = true;
          }
        });
      });

      if (!hasRelevantNodes || queued) return;
      queued = true;

      requestAnimationFrame(function () {
        hydrateButtons();
        queued = false;
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  // Public API
  window.APHWishlist = {
    read,
    write,
    has,
    toggle
  };

  onReady(function () {
    bindButtons();
    hydrateButtons();
    observeButtons();
    setCount();
  });

  document.addEventListener("aph:favorites:updated", function () {
    hydrateButtons();
    setCount();
  });
})();

/* =========================================================
   Header heart state + micro animation on add only
========================================================= */
(function () {
  function getCount() {
    try {
      return window.APHWishlist ? window.APHWishlist.read().length : 0;
    } catch (e) {
      return 0;
    }
  }

  function syncHeaderHeart(animate) {
    const icons = document.querySelectorAll(".aph-wishlist-launch");
    if (!icons.length) return;

    const count = getCount();
    const hasItems = count > 0;

    icons.forEach((icon) => {
      icon.classList.toggle("aph-wishlist-has", hasItems);

      if (animate) {
        icon.classList.remove("aph-wishlist-bloom");
        void icon.offsetWidth;
        icon.classList.add("aph-wishlist-bloom");
        clearTimeout(icon._aphBloomT);
        icon._aphBloomT = setTimeout(() => icon.classList.remove("aph-wishlist-bloom"), 520);
      }
    });
  }

  function init() {
    syncHeaderHeart(false);

    document.addEventListener("aph:favorites:updated", function (e) {
      const d = (e && e.detail) ? e.detail : {};
      const animate = d.action === "add";
      syncHeaderHeart(animate);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();